import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import GetDomains from '../../GetDomains'
import Select from 'react-select';


class Slu extends Component {
    constructor() {
        super();

        this.dialogClose = () => {
            this.setState({ hideDeletePopup: false, hideDeleteAllPopup: false, hideIncorrectPassword: false });
        };
        this.DeletedialogClose = () => {
            this.setState({ hideTextAreaPopup: false });
        }; this.IncorrectPassworddialogClose = () => {
            this.setState({ hideIncorrectPassword: false });
        };


        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteSluApi(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];
        //deleteall
        this.deleteAllButton = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': () => {
                this.setState({
                    hideDeleteAllPopup: false,
                    hideTextAreaPopup: true
                });
            }
        }, {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeleteAllPopup: false,
                });
            }
        }];



        //deleteall text confirmation
        this.textAreaConfir = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': () => {
                this.deleteInputValidation()
            }
        }, {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideTextAreaPopup: false,
                });
            }
        }];

        //incorrectPasswordButtons
        this.incorrectPasswordButtons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': () => {
                this.setState({
                    hideTextAreaPopup: true,
                    hideIncorrectPassword: false

                })
            }
        }];

        this.state = {
            inEditState: false,
            hideTextAreaPopup: false,
            hideIncorrectPassword: false,
            disabled: false,
            sluDomains: [],
            domainId: null,
            hideDeleteAllPopup: false,
            data: [
                {
                    id: '',
                    name: '',
                    description: '',
                    seamless:'',
                    unrelenting:'',
                    topLevel: '',
                    deleteRow: false
                }
            ],
            pageNum: null,
            disabled: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit2.png',
            hidden: false,
            hideAddDialog: false,
            hideupdateDialog: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            hideErrorAddingDialog: false,
            selectedDomainValue: null,
        }

        this.error

        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
        this.sluDomains = [];
    }

    notifyFailToLoad() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred.Please try again</b>, {
            position: "top-center",
            color: "red"
        });
    }

    addRow = (data) => {
        var sluController = this;
        if (sluController.state.pageNum != 0) {
            sluController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            id: '',
            name: '',
            description: '',
            seamless:'',
            unrelenting:'',
            topLevel: ''
        });
        this.setState({
            data: this.state.data,
            disabled: true
        })
    }

    saveSluApi = (props, e) => {
        var domainId = this.state.domainId;
        this.state.data[props.index].name = document.getElementById("name" + props.index).innerText.trim();
        this.state.data[props.index].description = document.getElementById("description" + props.index).innerText.trim();
        this.state.data[props.index].seamless = document.getElementById("seamless" + props.index).checked;
        this.state.data[props.index].unrelenting = document.getElementById("unrelenting" + props.index).checked;
        this.state.data[props.index].topLevel = document.getElementById("topLevel" + props.index).checked;
        this.state.editedId = "-1";
        this.setState(this.state);

        var validateResult = this.validateCells(props.original.name, props.original.description);

        if (validateResult == true) {
            var addedData = {
                name: this.state.data[props.index].name,
                description: this.state.data[props.index].description,
                seamless:this.state.data[props.index].seamless,
                unrelenting:this.state.data[props.index].unrelenting,
                topLevel: this.state.data[props.index].topLevel,
                projectId: localStorage.getItem("currentProjectId"),
                domainId: domainId
            };

            var addIntentController = this;
            $.ajax({
                url: "/api/slu-intent",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(addedData),
                processData: false,
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        addIntentController.notifyAdd();
                        addIntentController.state.disabled = false;
                        addIntentController.fetchSluApi();

                    } else if (res.success == false) {
                        this.error = res.result
                        addIntentController.notifyFailToLoadSlu(res.result);
                    } else {
                        addIntentController.notifyFailToLoadSlu(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            })

        }
    }

    notifyAdd() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Intent Added Successfully</b>, {
            position: "top-center",

        });

    }

    notifyFailToLoadSlu(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    validateCells(name, description) {
        if ((name == "" || description == "")) {
            this.notifyMsgFieldEmpty();
            return false;
        }
        else {
            return true;
        }

    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }

    makeCelleditable(props, e) {
        this.markAsBeingEdited(this.state.data[props.index].id);
    }
    markAsBeingEdited(id) {
        this.state.inEditState = true;
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    updateSluApi(props, e) {
        var domainId = document.getElementById("domain" + props.index).value;
        this.state.data[props.index].name = document.getElementById("name" + props.index).innerText.trim();
        this.state.data[props.index].description = document.getElementById("description" + props.index).innerText.trim();
        this.state.data[props.index].seamless = document.getElementById("seamless" + props.index).checked;
        this.state.data[props.index].unrelenting = document.getElementById("unrelenting" + props.index).checked;
        this.state.data[props.index].topLevel = document.getElementById("topLevel" + props.index).checked;

        var validateResult = this.validateCells(props.original.name, props.original.description, props.original.seamless,
            props.original.unrelenting, props.original.topLevel);
        if (validateResult == true) {
            var updatedData = {
                name: this.state.data[props.index].name,
                description: this.state.data[props.index].description,
                seamless:this.state.data[props.index].seamless,
                unrelenting:this.state.data[props.index].unrelenting,
                topLevel: this.state.data[props.index].topLevel,
                id: this.state.data[props.index].id,
                projectId: localStorage.getItem("currentProjectId"),
                domainId: domainId,
            };
            var updatedDataController = this;
            $.ajax({
                url: "/api/slu-intent",
                async: false,
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(updatedData),
                processData: false,
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        updatedDataController.state.editedId = "-1";
                        updatedDataController.notifyUpdate();
                        updatedDataController.state.disabled = false;
                        updatedDataController.fetchSluApi();
                    } else {
                        updatedDataController.notifyFailToUpdate(res.result);
                        updatedDataController.state.disabled = false;
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            })
        }
    }

    notifyUpdate() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Intent Updated Successfully</b>, {
            position: "top-center",

        });
    }
    notifyFailToUpdate(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }


    deleteSluApi = (id) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(id, 1);
        }
        $.ajax({
            url: "/api/slu-intent/" + id,
            async: false,
            method: 'DELETE',
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {

                if (res.success === true) {
                    deleteApiViewController.setState({ deleteRow: true });
                    deleteConstructorVariables.setState({ hideDeletePopup: false });
                    deleteRowViewController.splice(id, 1);
                    deleteConstructorVariables.notifyMsgDeleteSuccess();
                    deleteConstructorVariables.fetchSluApi();
                } else {
                    deleteConstructorVariables.setState({ hideDeletePopup: false });
                    deleteConstructorVariables.notifyFailToDelete(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    notifyMsgDeleteSuccess() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;User Intent Deleted Successfully</b>, {
            position: "top-center"
        });
    }
    notifyFailToDelete(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }
    deleteAllSluApi = () => {
        var domainId = this.state.domainId;
        let deleteApiViewController = this;
        $.ajax({
            url: "/api/intent/delete/all",
            async: false,
            method: 'POST',
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            data: {
                projectId: localStorage.getItem('currentProjectId'),
                domainId: domainId
            },
            success: function (res) {

                if (res.success === true && res.result === "done.") {
                    deleteApiViewController.state.hideTextAreaPopup = false;
                    deleteApiViewController.state.checkBoxRows = [];
                    deleteApiViewController.setState(deleteApiViewController.state);
                    deleteApiViewController.fetchSluApi();
                    deleteApiViewController.notifyDeleteAllSuccess();
                } else if (res.success === true && res.result != "done.") {

                    deleteApiViewController.notifyNodata(res.result);
                }


                else {
                    deleteApiViewController.notifyFailedDelete(res.result);
                }
            },

            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }

        });
    }
    notifyFailedDelete(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });


    }

    notifyDeleteAllSuccess() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
                content="" />&nbsp;&nbsp;All intents have been deleted Successfully</b>, {
            position: "top-center",
        });

    }
    notifyNodata(response) {
        this.setState({
            hideTextAreaPopup: false
        })
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });


    }
    deleteInputValidation = () => {
        if (document.getElementById('deleteInputFromUser').value == "Delete" ||
            document.getElementById('deleteInputFromUser').value == "delete" ||
            document.getElementById('deleteInputFromUser').value == "DELETE") {
            document.getElementById('deleteInputFromUser').value = "";
            this.deleteAllSluApi();
        }
        else {
            this.setState({
                hideIncorrectPassword: true
            })
        }
    }


    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.fetchSluApi()
        this.setState({ disabled: false })
    }

    fetchSluApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var sluController = this;
        var domainId = this.state.domainId;
        $.ajax({
            url: "/api/slu-intent",
            async: false,
            method: 'GET',
            data: {
                "projectId": projectId,
                domainId: domainId,
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    var messages = res.result;
                    sluController.state.inEditState = false;
                    sluController.setState({
                        data: messages,
                        disabled: false,
                    })
                }
                else {
                    sluController.notifyFailToLoadData(res.result);
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    notifyFailToLoadData(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    fetchDomains = () => {
        var domainList = GetDomains();
        var isDomainIdInCurrentProject = false;
        for (var i = 0; i < domainList.length; i++) {
            if (localStorage.getItem("sluDomainId") !== undefined &&
                domainList[i]["domainId"] === localStorage.getItem("sluDomainId")) {
                isDomainIdInCurrentProject = true;
            }
            this.sluDomains.push({ "value": domainList[i]["domainId"], "label": domainList[i]["domain"] });
        }

        if (this.props.location.state !== undefined) {
            if (isDomainIdInCurrentProject) {
                this.state.selectedDomainValue = localStorage.getItem("sluDomainName");
                this.state.domainId = localStorage.getItem("sluDomainId");
            } else {
                this.state.selectedDomainValue = this.sluDomains[0].label;
                this.state.domainId = domainList[0]["domainId"];
            }
        } else {
            this.state.selectedDomainValue = this.sluDomains[0].label;
            this.state.domainId = domainList[0]["domainId"];
        }
    }


    componentDidMount() {
        setTimeout(() => {
            this.fetchDomains();
            this.fetchSluApi();
        }, 300);


        var thisController = this;
        document.addEventListener("projectChanged", function (event) {
            thisController.projectId = event.projectId;
            thisController.sluDomains = [];
            thisController.state.disabled = false;
            thisController.fetchDomains();
            thisController.fetchSluApi(event.projectId);
        });
    }

    trigger = (props, e) => {
        this.props.history.push({
            pathname: '/projectmgmt/slu-trigger-details',
            state: {
                intentId: props.original.id,
                domainId: props.original.domainId,
                intentName: props.original.name

            }
        });
        this.setState(this.setState)
    }

    slots = (props, e) => {
        this.props.history.push({
            pathname: '/projectmgmt/slu-slot-details',
            state: {
                intentId: props.original.id,
                domainId: props.original.domainId,
                intentName: props.original.name
            }
        });
        localStorage.setItem("current-slot-name", props.original.name)
        this.setState(this.setState)
    }

    stopTrigger = (props, e) => {
        this.props.history.push({
            pathname: '/projectmgmt/slu-stop-trigger',
            state: {
                intentId: props.original.id,
                domainId: props.original.domainId,
                intentName: props.original.name

            }
        });
        this.setState(this.setState)
    }

    handleChange = (e) => {
        this.state.selectedDomainValue = e.label;
        this.state.domainId = e.value;
        localStorage.setItem("sluDomainName", e.label);
        localStorage.setItem("sluDomainId", e.value);
        this.setState(this.state);
        this.state.disabled = false;
        this.fetchSluApi();
    }

    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }

    handleTableDomainChange = (props, e) => {
        props.original.domainId = e.target.value;
        props.original.seamless = document.getElementById("seamless" + props.index).checked;
        props.original.unrelenting = document.getElementById("unrelenting" + props.index).checked;
        props.original.topLevel = document.getElementById("topLevel" + props.index).checked;
        props.original.name = document.getElementById("name" + props.index).innerText;
        props.original.description = document.getElementById("description" + props.index).innerText;
        this.setState(this.state);
    }

    render() {
        const selectedDomainOption = this.state.selectedDomainValue;
        const { data } = this.state
        const columns = [
            {
                Header: 'Id',
                accessor: 'id',
                sortable: false,
                show: false,
                Cell: props => (
                    <div name="id"
                        disabled
                        id={"id" + props.index}>
                        {props.original.id}
                    </div>)
            },
            {
                Header: <b> Name </b>,
                accessor: 'name',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{ width: '98%', padding: '8px', 
                    border: (props.original.id == "" || props.original.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == null) ? '2px' : 'none', paddingLeft: '2px' }}
                    contentEditable={!((props.original.id == "") ? false :
                        props.original.id != this.state.editedId) ? "plaintext-only" : false}
                    suppressContentEditableWarning
                    type="text" id={"name" + props.index}>{props.original.name}</div>)
            },
            {
                Header: <b> Description </b>,
                accessor: 'description',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{ width: '98%', padding: '8px', border: (props.original.id == "" || props.original.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == null) ? '2px' : 'none', paddingLeft: '2px' }}
                    contentEditable={!((props.original.id == "") ? false :
                        props.original.id != this.state.editedId) ? "plaintext-only" : false}
                    suppressContentEditableWarning
                    type="text" id={"description" + props.index}>{props.original.description}</div>)
            },

            {
                Header: <b>Category</b>,
                accessor: 'category',
                sortable: false,
                width: 200,
                show: this.state.inEditState,
                Cell: props => (
                    <div className="container-fluid" style={{ textAlign: "right" }}>
                        <select type="select-multiple" className="input-group form-control select2 "
                            value={props.original.domainId} id={"domain" + props.index}
                            onChange={(e) => this.handleTableDomainChange(props, e)}
                            style={{ background: 'white', border: 'none' }}
                            disabled={(props.original.id == "") ? false : props.original.id != this.state.editedId}>
                            {this.sluDomains.map(domain => (
                                <option key={domain.value} value={domain.value} >
                                    {domain.label}
                                </option>
                            ))}
                        </select>
                    </div>)
            },
            {
                Header: <b> Is Seamless </b>,
                accessor: 'seamless',
                sortable: false,
                width: 110,
                Cell: props => {
                    return (
                        <div style={{ textAlign: 'center', marginTop: '5px' }}>
                            <label class="switch">
                                <input type="checkbox"
                                    id={"seamless" + props.index}
                                    defaultChecked={props.original.seamless}
                                    disabled={(props.original.id == "") ? false : props.original.id != this.state.editedId}
                                />
                                <span class="slider round"></span>
                            </label>
                        </div>
                    )
                }
            },
            {
                Header: <b> No Context Switching </b>,
                accessor: 'unrelenting',
                sortable: false,
                width: 180,
                Cell: props => {
                    return (
                        <div style={{ textAlign: 'center', marginTop: '5px' }}>
                            <label class="switch">
                                <input type="checkbox"
                                    id={"unrelenting" + props.index}
                                    defaultChecked={props.original.unrelenting}
                                    disabled={(props.original.id == "") ? false : props.original.id != this.state.editedId}
                                />
                                <span class="slider round"></span>
                            </label>
                        </div>
                    )
                }
            },
            {
                Header: <b> Is Top Level </b>,
                accessor: 'topLevel',
                sortable: false,
                width: 110,
                Cell: props => {
                    return (
                        <div style={{ textAlign: 'center', marginTop: '5px' }}>
                            <label class="switch">
                                <input type="checkbox"
                                    id={"topLevel" + props.index}
                                    defaultChecked={props.original.topLevel}
                                    disabled={(props.original.id == "") ? false : props.original.id != this.state.editedId}
                                />
                                <span class="slider round"></span>
                            </label>
                        </div>
                    )
                }
            },
            {
                Header: <b> Action </b>,
                accessor: 'action',
                sortable: false,
                width: 300,
                Cell: props => (
                    <div id="action">
                        {/* edit button */}
                        <div>
                            <p><button className="btn2 table-action-button "
                                onClick={(e) => {
                                    this.slots(props, e)
                                }}
                                hidden={(props.original.id == "") ? true : false}>
                                Slots</button>

                                <button className="btn2 table-action-button "
                                    onClick={(e) => {
                                        this.trigger(props, e)
                                    }}
                                    hidden={(props.original.id == "") ? true : false}>
                                    Trigger</button>
                                <button className="btn2 table-action-button "
                                    onClick={(e) => {
                                        this.stopTrigger(props, e)
                                    }}
                                    hidden={(props.original.id == "") ? true : false}>
                                    StopTrigger</button>
                                <button style={{
                                    backgroundColor: "#ffffff", border: "none",
                                    marginTop: '-13px'
                                }}>
                                    <img className="img-responsive"
                                        style={{ marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                        title={(props.original.id == "") ||
                                            (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                                        src={(props.original.id == "") ?
                                            this.saveImageSrc : ((props.original.id != this.state.editedId) ?
                                                this.editImageSrc : this.saveImageSrc)}
                                        onClick={(e) => {
                                            (props.original.id == "") ?
                                                this.saveSluApi(props, e) :
                                                (props.original.id == this.state.editedId) ?
                                                    this.updateSluApi(props, e) :
                                                    this.makeCelleditable(props, e);
                                        }}
                                    /></button>
                                <button style={{
                                    backgroundColor: "#ffffff",
                                    border: "none",
                                    marginTop: '-9px', marginLeft: '-6px'
                                }}
                                    title="Delete">
                                    <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                                        style={{
                                            marginTop: '6px',

                                            backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                                        }}

                                        onClick={() => (props.original.id) === '' ?
                                            this.fetchSluApi() :
                                            this.setState({
                                                hideDeletePopup: true, deletePropIndex: props.index,
                                                propsId: props.original.id
                                            })}
                                    /></button>
                            </p>
                        </div>
                    </div>
                ),
            },
        ]
        return (
            <div>
                {/* for toaster */}
                <link rel="stylesheet" href="./assets/css/ReactToastify.css" />
                {/* for reactTable */}
                <link rel="stylesheet" href="./assets/css/React_Table_CSS/react-table.css" />
                <link rel="stylesheet" href="./assets/css/react-table-height.css" />
                {/* for dialog component */}
                <link href="./assets/css/ej2-base.css" rel="stylesheet" />
                <link href="./assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="./assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="./assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="./assets/css/screenResolution.css" rel="stylesheet" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />

                <div className="col-sm-12" style={{ backgroundColor: '#F9F9FB', marginTop: '-21px ' }}>
                    <div className="row">
                        <div className="col-sm-7">
                            <h6 className="nav-item" style={{
                                color: '#282a65',
                                marginTop: '25px', marginLeft: '10px'
                            }}>Define User Intents</h6>
                        </div>

                        <div className="d-flex flex-row-reverse pt-2 col-sm-5">

                            {/* Refresh Page */}
                            <button onClick={this.refreshData} className="btn action-button" title="Refresh">
                                <img src="./assets/images/refresh_white_24dp.png"></img>
                            </button>

                            {/* Add Row Button */}

                            <button className="btn action-button "
                                title="Add"
                                id="addMsg"
                                onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addRow}>
                                <img src="assets/images/add_white_24dp.png" />
                            </button>
                            {/* <button className="btn action-button"
                                style={{ marginTop: '5px' }}
                                id="addMsg" title=" Delete All "
                                onClick={() => {
                                    this.setState({
                                        hideDeleteAllPopup: true
                                    })
                                }}>
                                Delete All
                            </button> */}
                            <Select
                                value={this.sluDomains.filter(option => option.label === selectedDomainOption)}
                                onChange={this.handleChange}
                                options={this.sluDomains} />
                        </div>
                    </div>
                </div>
                <div style={{ marginTop: "21px" }}>
                    <ReactTable
                        data={data}
                        columns={columns}
                        defaultPageSize={10}
                        style={{
                            backgroundColor: 'white',
                            marginRight: '12px', marginLeft: '12px'
                        }}
                        pageSizeOptions={[5, 10, 15]}
                        onPageChange={this.onPageChange}
                        page={this.state.pageNum}
                    /></div>

                <ToastContainer className="Toast-at-center" />

                {/*Dialog Component For Deletion Confirmation*/}
                <DialogComponent width='400px' animationSettings={this.settings}
                    header='User-Intent' showCloseIcon={true} buttons={this.buttons}
                    ref={dialog => this.dialogInstance = dialog}
                    visible={this.state.hideDeletePopup} close={this.dialogClose}>
                    <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                        content="" />&nbsp;Do you want to delete the Intent? &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>
                {/*Dialog Component For  Deletion all Confirmation*/}
                <DialogComponent width='400px' animationSettings={this.settings}
                    header='Delete All' showCloseIcon={true} buttons={this.deleteAllButton}
                    ref={dialog => this.dialogInstance = dialog}
                    visible={this.state.hideDeleteAllPopup} close={this.dialogClose}>
                    <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                        content="" />&nbsp;Do you want to delete all the intents?<br />Note: Press 'Yes' to delete or press 'No' to decline.
                </DialogComponent>
                <DialogComponent width='400px' animationSettings={this.settings}
                    header='Incorrect Password' showCloseIcon={true} buttons={this.incorrectPasswordButtons}
                    ref={dialog => this.dialogInstance = dialog}
                    visible={this.state.hideIncorrectPassword} close={this.IncorrectPassworddialogClose}>
                    Please type "Delete"
                </DialogComponent>


                <DialogComponent width='400px' animationSettings={this.settings}
                    header='Delete Confirmation' showCloseIcon={true} buttons={this.textAreaConfir}
                    ref={dialog => this.dialogInstance = dialog}
                    visible={this.state.hideTextAreaPopup} close={this.DeletedialogClose}>
                    Please type "Delete" for confirmation<input type="text" id="deleteInputFromUser" />
                </DialogComponent>
            </div>
        )

    }
}

export default Slu;


// WEBPACK FOOTER //
// ./src/projectmgmt/nlu/intent/Slu.js